import { create, FedopsLogger } from '@wix/fedops-logger';
import { InteractionName } from '../../types/InteractionName';
import { globals } from '../globals';

const noop = (): any => null;

export type WalletFedopsLogger = FedopsLogger<InteractionName>;

export const FEDOPS_LOGGER_ID = 'cashier-wallet';

const createMockLogger = (): WalletFedopsLogger =>
  ({
    appLoaded: noop,
    interactionEnded: noop,
    interactionStarted: noop,
  } as any);

export const fedopsLogger: WalletFedopsLogger = globals.enableMonitoring
  ? create(FEDOPS_LOGGER_ID)
  : createMockLogger();
